module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-list"
  }, [_c('h3', {
    staticClass: "monospaced"
  }, [_vm._v("$ ls -la ↵")]), _vm._v(" "), _vm._l((_vm.projects), function(p) {
    return _c('project-item', {
      key: p.name,
      attrs: {
        "project": p
      }
    })
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-375902fa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ProjectList.vue
// module id = 22
// module chunks = 0